"use client";
import { motion } from "framer-motion";
import { IconPhone, IconMail, IconHeart, IconUsers, IconHandMove } from "@/lib/tabler-icons";
import { CONFIG } from "@/constants/config";
import Image from "next/image";
import { SectionHeading, Caption } from "@/components/ui/editorial";

export default function AgradecimientoSection() {
	return (
		<section className="px-4 xl:px-0 py-16 border-t border-border">
			<div className="container max-w-7xl mx-auto space-y-16">
				<div className="grid lg:grid-cols-2 gap-16 items-start">
					{/* Panel izquierdo - Texto y contacto */}
					<motion.div
						initial={{ opacity: 0, x: -20 }}
						whileInView={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.8 }}
						viewport={{ once: true }}
						className="space-y-8"
					>
						{/* Nombre del autor */}
						<p className="font-display text-sm text-terracotta uppercase tracking-widest">
							Aránzazu G. Butler
						</p>

						{/* Título principal */}
						<SectionHeading
							index="06"
							title="Muchas Gracias"
						/>

						{/* Mensaje de agradecimiento */}
						<p className="font-body text-xl text-ink/80 leading-relaxed">
							Porque reconocer lo que no se ve es el primer paso para transformar
							vidas, acompañar desde la escucha y construir vínculos que sanan.
							Sigamos despertando conciencia, cuidando la infancia y promoviendo
							relaciones más justas y afectivas.
						</p>

						{/* Información de contacto */}
						<div className="space-y-4 pt-4 border-t border-border">
							<div className="flex items-center gap-4">
								<div className="w-9 h-9 border border-border rounded-full flex items-center justify-center text-terracotta shrink-0">
									<IconPhone className="w-4 h-4" />
								</div>
								<p className="font-body text-ink/80">
									{CONFIG.CONTACT_PHONE}
								</p>
							</div>

							<div className="flex items-center gap-4">
								<div className="w-9 h-9 border border-border rounded-full flex items-center justify-center text-terracotta shrink-0">
									<IconMail className="w-4 h-4" />
								</div>
								<p className="font-body text-ink/80">
									{CONFIG.CONTACT_EMAIL}
								</p>
							</div>
						</div>

						{/* Sitio web */}
						<div className="flex items-center gap-4">
							<hr className="border-border flex-1" />
							<span className="font-body text-sm text-muted-foreground">
								{CONFIG.URL.replace("https://", "www.")}
							</span>
							<hr className="border-border flex-1" />
						</div>

						{/* Elementos decorativos */}
						<div className="flex items-center gap-6">
							<div className="flex items-center gap-2">
								<IconHeart className="w-4 h-4 text-terracotta" />
								<span className="font-body text-sm text-muted-foreground">
									Con amor
								</span>
							</div>
							<div className="flex items-center gap-2">
								<IconUsers className="w-4 h-4 text-ink/60" />
								<span className="font-body text-sm text-muted-foreground">
									Para la comunidad
								</span>
							</div>
							<div className="flex items-center gap-2">
								<IconHandMove className="w-4 h-4 text-ink/60" />
								<span className="font-body text-sm text-muted-foreground">
									Juntos
								</span>
							</div>
						</div>
					</motion.div>

					{/* Panel derecho - Imagen */}
					<motion.div
						initial={{ opacity: 0, x: 20 }}
						whileInView={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.8, delay: 0.2 }}
						viewport={{ once: true }}
					>
						<figure>
							<div className="relative w-80 h-80 mx-auto rounded-full border border-border overflow-hidden">
								<Image
									src="/assets/todo-lo-que-no-ves/thanks.jpeg"
									alt="Agradecimiento — Aránzazu G. Butler"
									fill
									sizes="320px"
									className="object-cover"
								/>
							</div>
							<Caption className="text-center">Aránzazu G. Butler</Caption>
						</figure>
					</motion.div>
				</div>

				{/* Mensaje final */}
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, delay: 0.4 }}
					viewport={{ once: true }}
					className="border border-border rounded-xl p-8 lg:p-12"
				>
					<div className="max-w-3xl mx-auto text-center space-y-6">
						<h3 className="font-display text-2xl md:text-3xl font-semibold text-ink">
							Sigamos construyendo juntos
						</h3>
						<p className="font-body text-lg text-ink/80 leading-relaxed">
							Cada acción, cada taller, cada encuentro es una semilla que germina
							en conciencia, empatía y transformación. Gracias por ser parte de
							este viaje hacia un mundo más compasivo y consciente.
						</p>
						<blockquote className="border-l-2 border-terracotta pl-6 text-left inline-block">
							<p className="font-display italic text-terracotta text-xl">
								&ldquo;Porque juntos, todo es posible.&rdquo;
							</p>
						</blockquote>
					</div>
				</motion.div>
			</div>
		</section>
	);
}
